export default __webpack_public_path__ + "static/media/newsfeed.975cbf66.svg";